import Image from 'next/image'

import { ButtonLink } from '@/components/primitives/Button/Button'
import { asHttpSrc } from '@/lib/utils'

import type { FooterType } from '@/types/contentful/footerType'

export const ContactUsBanner = ({ banner }: { banner: FooterType['fields']['banner'] }) => {
  const { title, ctaLabel, ctaLink, backgroundImage } = banner?.fields ?? {}
  const imageUrl = asHttpSrc(backgroundImage?.fields?.file?.url)

  return (
    <div className="relative w-full bg-neutral-500 px-6 py-12 md:px-12 md:py-14 lg:px-12 lg:py-16">
      {imageUrl && <Image src={imageUrl} alt="" fill sizes="100vw" className="z-0 object-cover" />}
      <div className=" flex flex-col items-center justify-between md:flex-row content:mx-auto content:max-w-content">
        {title && <p className="z-10 mb-6 w-80 text-lg font-semibold leading-6 text-white md:mb-0 lg:w-auto">{title}</p>}
        <div className="z-10 grid">
          {ctaLink && ctaLabel && (
            <div className="h-12 w-fit rounded-full bg-border-gradient p-[1.2px]">
              <ButtonLink className="flex size-full items-center justify-center rounded-full bg-accent-green-1 px-8" href={ctaLink}>
                {ctaLabel}
              </ButtonLink>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ContactUsBanner
